import { Stars, STARS_ENUMS } from './Stars'
import s from './ReviewRating.module.scss'

export const DEFAULT_STARS_GRANULARITY_PERCENT = 0.5
export const DEFAULT_ONE_STAR_SHARE = 1
export const DEFAULT_STARS_COUNT = 5

type ProductReviewStarsProps = {
    averageScore: number
    areaLabel?: string
    starsCount?: number
    oneStarShare?: number
    starPercent?: number
}

export const ProductReviewStars = ({
    averageScore,
    areaLabel = 'out of 5',
    starsCount = DEFAULT_STARS_COUNT,
    oneStarShare = DEFAULT_ONE_STAR_SHARE,
    starPercent = DEFAULT_STARS_GRANULARITY_PERCENT
}: ProductReviewStarsProps) => {
    const getStarCounts = () => {
        const percentRounded =
            Math.round(averageScore / starPercent) * starPercent
        const fullCount = Math.floor(percentRounded / oneStarShare)
        const halfFullCount =
            percentRounded % oneStarShare === starPercent ? 1 : 0
        const emptyCount = starsCount - fullCount - halfFullCount

        return {
            fullCount,
            halfFullCount,
            emptyCount
        }
    }
    const { fullCount, halfFullCount, emptyCount } = getStarCounts()
    return (
        <div
            className={s['reviewRating']}
            title={`${averageScore}%`}
            area-label={areaLabel}
        >
            <Stars count={fullCount} starFillType={STARS_ENUMS.FULL} />
            <Stars count={halfFullCount} starFillType={STARS_ENUMS.HALF} />
            <Stars count={emptyCount} starFillType={STARS_ENUMS.EMPTY} />
        </div>
    )
}
